module.exports = __webpack_public_path__ + "static/media/bg_galaxie_mobile.a760968f.jpg";